import { WirelessHealthDetail, WirelessKpiAruba } from "../../apis/networkdashboard/rest/models";
import { HealthRecord, HealthStatus } from "../../apis/stats/rest/models";

export const EMPTY_HEALTH: HealthRecord = {
  status: HealthStatus.Unknown,
  in: 0,
  out: 0,
};

export const EMPTY_WIRELESS_HEALTH = {
  activeAps: 0,
  inactiveAps: 0,
  kpiAverages: {
    DHCP_RES_TIME: 0,
    WIFI_ASSOC_TIME: 0,
    DNS_RES_TIME: 0,
    VOICE_QUALITY: 0,
    THROUGHPUT_UP: 0,
    THROUGHPUT_DOWN: 0,
    RADIUS: 0,
    DHCP: 0,
    MOSVOIPUP: 0,
    MOSVOIPDOWN: 0,
    THROUGHPUTUP: 0,
    THROUGHPUTDOWN: 0,
  },
};

const EMPTY_ARUBA_KPIS: WirelessKpiAruba = {
  DHCP_RES_TIME: 0,
  DNS_RES_TIME: 0,
  RADIUS: 0,
  THROUGHPUT_DOWN: 0,
  THROUGHPUT_UP: 0,
  VOICE_QUALITY: 0,
  WIFI_ASSOC_TIME: 0,
};

export const EMPTY_WIRELESS_KPIS: WirelessHealthDetail = {
  apCountsByModel: {},
  last3Days: {
    twofour: EMPTY_ARUBA_KPIS,
    five: EMPTY_ARUBA_KPIS,
    six: EMPTY_ARUBA_KPIS,
    maxActiveUsers: 0,
  },
  lastWeek: {
    twofour: EMPTY_ARUBA_KPIS,
    five: EMPTY_ARUBA_KPIS,
    six: EMPTY_ARUBA_KPIS,
    maxActiveUsers: 0,
  },
  today: {
    twofour: EMPTY_ARUBA_KPIS,
    five: EMPTY_ARUBA_KPIS,
    six: EMPTY_ARUBA_KPIS,
    maxActiveUsers: 0,
  },
};
